module.exports = __webpack_public_path__ + "static/media/glasses.6cbc4451.jpg";